export { REDIRECT_URL_KEY } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/routingConstants'

export const TREATMENT_RECOMMENDATIONS_ROUTE = '/secure/onboard/treatment-options'

// Paths where the OnboardingNavBar is embedded inside the page component (not rendered by MainAppLayout).
// On these paths with Aurora enabled, the banner must not contribute layout height or it will push
// the transparent sticky header away from the top of the viewport.
export const AURORA_BANNER_EXCLUDED_PATHS = ['/secure/onboard/about', '/secure/onboard/about/:id']

export const NEGATIVE_PADDING_PATHS = [
  '/secure/onboard/t1-multi-providers',
  '/secure/onboard/t1-multi-providers/latest-provider-matches',
  '/secure/onboard/coaches',
  '/secure/onboard/coaches/latest-provider-matches',
  '/secure/onboard/provider/:id/schedule',
  '/secure/index/provider/:id/therapy-care-options/',
  '/secure/index/provider/:id/coaching-options',
]
